import * as React from "react";
const SvgFiRrShieldSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-shield-slash_svg__a)">
      <path
        fill="#062147"
        d="M16.268 20.713a1 1 0 0 1-.292 1.384 19 19 0 0 1-3.182 1.663s-.43.24-.792.24-.85-.307-.85-.307C9.005 22.62 2 18.605 2 12.043v-3.55a1 1 0 1 1 2 0v3.55c0 5.416 6.16 8.917 8.047 9.861a17 17 0 0 0 2.837-1.483 1.003 1.003 0 0 1 1.385.292m7.44 2.994a.997.997 0 0 1-1.415 0l-22-22A.999.999 0 1 1 1.707.293l2.46 2.46a5 5 0 0 1 1.26-.627L11.684.051a1 1 0 0 1 .63 0l6.26 2.075A4.99 4.99 0 0 1 22 6.872v5.171c0 2.35-.71 4.51-2.11 6.432l3.817 3.818a1 1 0 0 1 0 1.414M5.621 4.207 18.454 17.04a8.73 8.73 0 0 0 1.547-4.996v-5.17a3 3 0 0 0-2.056-2.849l-5.944-1.97-5.944 1.97q-.226.075-.435.183"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-shield-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrShieldSlash;
